/**
 * FetchSlice helpers — contracts §2 in CR-mentor-fe-architecture-recovery-01-contracts.md
 */

export function makeFetchSlice(initialData = []) {
  return {
    data: initialData,
    status: 'idle',
    error: null,
    errorDetail: null,
    fetchedAt: null,
  };
}

export function sliceLoading(prev) {
  return {
    ...prev,
    status: 'loading',
    error: null,
    errorDetail: null,
  };
}

export function sliceSuccess(data, prev) {
  return {
    data,
    status: 'success',
    error: null,
    errorDetail: null,
    fetchedAt: Date.now(),
  };
}

export function sliceError(err, prev, userMessage = 'Failed to load data', errorDetail = null) {
  const detail = errorDetail
    ?? (err && typeof err === 'object' && err.message ? err.message : err != null ? String(err) : null);
  return {
    data: prev?.data ?? [],
    status: 'error',
    error: userMessage,
    errorDetail: detail,
    fetchedAt: prev?.fetchedAt ?? null,
  };
}